import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dropdown-heading',
  templateUrl: './dropdown-heading.component.html',
  styleUrls: ['./dropdown-heading.component.scss']
})
export class DropdownHeadingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
